
import Api from "@/api/userService";
import ResultCodeType from "@/constant/ResultCodeType";
import {
  showToast,
  toast_error_type,
  toast_success_type,
} from "@/utils/ShowCompUtils";
import { computed, defineComponent, PropType, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import LoadingPage from "@/components/LoadingPage.vue";
import { useI18n } from "vue-i18n";

export default defineComponent({
  components: { LoadingPage },
  name: "ReStart",
  props: {
    vin: {
      type: String as PropType<string>,
      required: true,
      defualt: "",
    },
  },
  setup(props, context) {
    const router = useRouter();
    const route = useRoute();
    const carVin = computed<string>(() => props.vin);
    const isLoading = ref(false);
    const { t } = useI18n();

    const logBags = () => {
      isLoading.value = true;
      Api.logBags(carVin.value)
        .then((val) => {
          isLoading.value = false;
          if (val) {
            if (val?.err_no == ResultCodeType.success_200) {
              showToast(t("recorded"), toast_success_type);
            } else {
              showToast(val.err_msg, toast_error_type);
            }
          }
        })
        .catch(() => {
          showToast(t("recordfailed"), toast_error_type);
          isLoading.value = false;
        });
    };

    return { logBags, isLoading, t };
  },
});
